export default {
    tagline: {
        title: 'calculate better...',
        services: [
           'and faster'
        ]
    }
}



// WEBPACK FOOTER //
// ./src/components/messages.js